export default __webpack_public_path__ + "static/media/GL.15c3d91b.svg";